/**
 * Created by Tony on 10/08/2016.
 */

publishingApp.service('dbData', function ($http, $rootScope) {
    // Post to DB
    this.post = function (url, config) {
        return $http.post(url, config);
    };

    // Delete from DB
    this.delete = function (url, config) {
        return $http.delete(url, config);
    };

    // Get from DB
    this.get = function (url, config) {
        return $http.get(url, config);
    };

    // HEAD from DB
    this.head = function (url) {
        return $http.head($rootScope.absUrl + url);
    };

    // Put to DB
    this.put = function (url, config) {
        return $http.put(url, config);
    };

    // Put to DB
    this.patch = function (url, config) {
        return $http.patch(url, config);
    };

    // Tree JSON
    this.getTree = function () {
        return $http({
            method: 'get',
            url: '/tree/' + $rootScope.currentCourse
        });
    };

    this.getUsers = function ($filter_query) {
        return $http({
            method: 'get',
            url: '/api/users/?' + $filter_query
        });
    };
});